module.exports = "<p>\n  new works!\n</p>\n"